<template>
  <div style="display: flex; align-items: center">
    <span style="margin-right: 10px; width: 100px"> {{ i18nJS.guests.index.title }} </span>
    <!-- usare v-select2 con :selectConfig così non va bene -->
    <v-select2
      @input="selectRequirement()"
      :optionsList="guests"
      :value="params.guest_period_data_set_id"
      :disabled="isLoading"
      :multiple="false"
      data-allow-clear="true"
      :data-placeholder="'Seleziona un elemento'"
      :data-ajax--url="url + '.json?business_unit_id=' + buId + '&with_gpds=true'"
      data-minimumInputLength="0"
      data-pageLimit="20"
      id="requirement_guest_id"
    >
    </v-select2>
    <spinner :visible="isLoading"></spinner>
  </div>
</template>

<script>
import vSelect2 from '../../vSelect2';
import apiConnector from '@/epersonam/apiConnector';
import spinner from '../../spinner';
import { Route } from '../../../route';
export default {
  name: 'guestRequirement',
  props: ['valueSelected', 'buId', 'index', 'params'],
  components: {
    vSelect2,
    spinner,
  },
  data() {
    return {
      isLoading: false,
      result: null,
      url: '/it/guests',
      guests: [],
    };
  },
  mounted() {
    if (this.params.guest_period_data_set_id) {
      this.isLoading = true;
      apiConnector()
        .get(`${Route.GUEST_PERIOD_DATA_SET}/${this.params.guest_period_data_set_id}.json?with_gpds=true`)
        .then((res) => {
          this.isLoading = false;
          this.guests.push([res.data.full_name, this.params.guest_period_data_set_id]);
          eventBus.$emit('guestRequirementSelected', this.params.guest_period_data_set_id);
          this.$emit('selected', { data_selected: res.data, index: this.index });
          eventBus.$emit('guest_period_data_set_id_selected', res.data.gpds_id);
        });
    }
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  methods: {
    selectRequirement() {
      const data_selected = $('#requirement_guest_id').select2('data')[0];
      // puo essere null se e' creato al solo scopo di ricevere un gpds id (cioe' un report utente stampato non dalla cartella)
      if (this.index != null) {
        this.$emit('selected', { data_selected, index: this.index });
      }
      eventBus.$emit('guestRequirementSelected', data_selected.id);
      eventBus.$emit('guest_period_data_set_id_selected', data_selected.gpds_id);
    },
  },
};
</script>

<style lang="scss" scoped></style>
